import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.75 4.75h10.5c.957 0 1.75.793 1.75 1.75v7.875c0 .984-.793 1.75-1.75 1.75h-3.8l-3.391 2.543c-.137.11-.301.11-.465.055a.45.45 0 0 1-.219-.41v-2.188H6.75c-.984 0-1.75-.766-1.75-1.75V6.5c0-.957.766-1.75 1.75-1.75"
    }, null, -1)
  ]))]))
}
export default { render: render }